/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theeventhasbeenremovedsuccessfully5Inputs */

const en_theeventhasbeenremovedsuccessfully5 = /** @type {(inputs: Theeventhasbeenremovedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The event has been removed successfully.`)
};

const de_theeventhasbeenremovedsuccessfully5 = /** @type {(inputs: Theeventhasbeenremovedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Event wurde entfernt.`)
};

/**
* | output |
* | --- |
* | "The event has been removed successfully." |
*
* @param {Theeventhasbeenremovedsuccessfully5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const theeventhasbeenremovedsuccessfully5 = /** @type {((inputs?: Theeventhasbeenremovedsuccessfully5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theeventhasbeenremovedsuccessfully5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_theeventhasbeenremovedsuccessfully5(inputs)
	return de_theeventhasbeenremovedsuccessfully5(inputs)
});
export { theeventhasbeenremovedsuccessfully5 as "theEventHasBeenRemovedSuccessfully" }